<template>
  <div style="padding: 20px">
    <div>
      <div class="upload-wrap">
        <el-button type="primary">增量导入</el-button>
        <input @change="(e) => changeFile(e, 2)" accept=".xlsx" type="file" />
      </div>
      <div class="upload-wrap">
        <el-button type="primary">全量导入</el-button>
        <input @change="(e) => changeFile(e, 1)" accept=".xlsx" type="file" />
      </div>
      <div class="upload-wrap">
        <el-button type="text" @click="downloadTemplate">下载模板</el-button>
      </div>
    </div>
    <el-table class="myTable" :data="tableData">
      <el-table-column prop="createdAt" label="导入时间"></el-table-column>
      <el-table-column prop="fileName" label="文件名">
        <template slot-scope="scope">
          <el-button type="text" @click="download(scope.row)">{{
            scope.row.fileName
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型"
        ><template slot-scope="scope">
          {{ scope.row.type == 1 ? "全量" : scope.row.type == 2 ? "增量" : "" }}
        </template></el-table-column
      >
      <el-table-column prop="operationUser" label="操作人"></el-table-column>
    </el-table>
    <el-pagination
      style="text-align: right; margin: 20px 0; padding-bottom: 20px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[15, 25, 30, 50]"
      :page-size="pageSize"
      layout="total, prev, pager, next,sizes, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import utils from "@/utils/util";
import { downloadFile, formatDateTime } from "@/utils/functions";
import {
  getImportSellerNoReasonAfterSaleConfigSpuRecord,
  importSellerNoReasonAfterSaleConfigSpu,
  downloadFileUrl,
} from "../api.js";
import {
  fileUpload,
  getBrandList,
  category,
  seasonList,
} from "@/api/merchants";
import Client from "@/utils/client.js";

import BrandSelect from "@/views/components/brandSelect.vue";

export default {
  data() {
    return {
      vendorList: [],
      cities: [],
      activityName: "",
      currentPage: 1,
      pageSize: 15,
      total: 0,
      ruleForm: {},
      rules: {
        brandIds: [
          { required: true, message: "请选择品牌。", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入描述", trigger: "blur" }],
      },
      dialogVisible: false,
      tableData: [],
      brandList: [],
      brandNameList: [],
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true,
      },
    };
  },
  components: { BrandSelect },
  created() {},
  mounted() {
    getBrandList().then((res) => {
      this.brandList = (res.data || []).map((item) => ({
        label: item.englishName,
        value: item.brandId,
      }));
      this.brandNameList = (res.data || []).map((item) => ({
        label: item.englishName,
        value: item.englishName,
      }));
    });
    this.query();
  },
  methods: {
    query() {
      this.currentPage = 1;
      this.getTableData();
    },
    resetQuery() {
      this.currentPage = 1;
      this.getTableData();
    },
    handleClose() {
      this.$refs["ruleForm"].resetFields();
      this.dialogVisible = false;
    },
    async getTableData() {
      let targetObj = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      this.$store.commit("setPageLoading", true);
      let res = await getImportSellerNoReasonAfterSaleConfigSpuRecord(
        targetObj
      );
      this.$store.commit("setPageLoading", false);
      if (res.success && res.data) {
        let { total, list } = res.data;
        this.total = total;
        this.tableData = (list || []).map((item) => {
          return {
            ...item,
            createdAt: formatDateTime(item.createdAt, "yyyy-MM-dd HH:mm:ss"),
          };
        });
      } else {
        this.$message.error(`${resData.message}`);
        return;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    downloadTemplate() {
      downloadFileUrl(
        "https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/i3XAzh_1772786387334.xlsx"
      ).then((res) => {
        downloadFile(res.data, "无理由配置模版.xlsx");
      });
    },
    download(row) {
      downloadFileUrl(row.fileUrl).then((res) => {
        downloadFile(res.data, row.fileName);
      });
    },
    async changeFile(e, type) {
      try {
        if (e && e.target && e.target.files && e.target.files[0]) {
          const file = e.target.files[0];
          if (!/\.xlsx$/.test(String(file.name).toLowerCase())) {
            this.$message.error("上传文件格式非法，请上传xlsx文件");
            return;
          }
          if (file.size > 10 * 1024 * 1024) {
            this.$message.error("文件最大10m");
            return;
          }
          this.$store.commit("setPageLoading", true);
          const confRes = await fileUpload();
          const OSSClient = Client(confRes.data.data);
          const fileName =
            this.random_string(6) +
            "_" +
            new Date().getTime() +
            "." +
            file.name.split(".").pop();
          const random_name = "tmp/" + fileName;
          const resFile = await OSSClient.put(random_name, file);
          var params = {
            updateType: type,
            fileName: file.name,
            fileUrl: resFile.url.replace("http://", "https://"),
          };
          const res = await importSellerNoReasonAfterSaleConfigSpu(params);
          this.$store.commit("setPageLoading", false);
          if (res.success) {
            this.getTableData();
            this.$message.success("导入成功");
          } else {
            if ((res.code == 1001 && res.data)) {
              this.$message.error(res.message + ",已自动下载");
              let url = res.data.replace("http:", "https:");
              downloadFileUrl(url).then((resP) => {
                downloadFile(resP.data, "错误文件.xlsx");
              });
            } else {
              this.$message.error(res.message || "系统异常");
            }
          }
        }
        e.target.value = "";
      } catch (error) {
        this.$store.commit("setPageLoading", false);
      }
    },
    random_string(len) {
      len = len || 32;
      let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678",
        maxPos = chars.length,
        pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  },
};
</script>
<style lang="less" scoped>
.dialogContainer .el-checkbox {
  margin-left: 0;
  margin-right: 20px;
  margin-bottom: 5px;
}
.manipulate {
  margin-right: 12px;
  color: #409eff;
  cursor: pointer;
}
.dot {
  display: inline-block;
  margin-right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.gray {
  background: #cccccc;
}
.green {
  background: green;
}
.dropdown-item {
  margin: 0;
  padding: 7px 16px;
  clear: both;
  color: #657180;
  font-size: 12px !important;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.demo-ruleForm {
  margin: 20px 0px;
}
.flex {
  height: 80px;
  padding-top: 13px;
  padding-left: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}
.absolute {
  position: absolute;
  top: 0;
  left: 168px;
}
.upload-wrap {
  position: relative;
  display: inline-block;
  margin-left: 10px;

  input {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 10;
  }
}
</style>
